import React from 'react'
import './ContractVehiclesHero.scss'

export class ContractVehiclesHero extends React.Component {
  render() {
    return (
      <div
        className="contact-hero"
        style={{ backgroundImage: 'url(/contactbg.jpg)' }}
      >
        <div className="overlay" />
        <div className="inner-wrap">
          <div className="text">
            <h1>{this.props.title || 'Contract Vehicles & Certifications'}</h1>
          </div>
        </div>
      </div>
    )
  }
}

export default ContractVehiclesHero
